import React from "react";
import Sidebar from "../../components/Sidebar/Sidebar";
import Topbar from "../../components/Topbar/Topbar";
import { Box, Typography } from "@mui/material";

const Settings = () => {
  return (
    <Box sx={{ display: "flex" }}>
      <Sidebar collapsed={false} toggleSidebar={() => {}} active="Settings" />
      <Box component="main" sx={{ flexGrow: 1, p: 3, mt: 8 }}>
        <Topbar notificationCount={1} />
        <Typography variant="h4">Settings</Typography>
        <Typography sx={{ mt: 2 }}>
          This is the settings page. Configure your LMS admin panel here.
        </Typography>
      </Box>
    </Box>
  );
};

export default Settings;
